import { type AirlineIconProps, AirlineIcon as CssModulesAirlineIcon } from '@sunwebgroup/uds-ui/airline-icon'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/airline-icon' instead.
 */
export default Object.assign(
  styled(CssModulesAirlineIcon)<AirlineIconProps>``,
  { displayName: 'AirlineIcon' },
)
